import { Route, Routes } from 'react-router-dom';

import { NotFound } from 'common/components';

//import Table from './components/Table';
import CreateReceipt from './components/CreateReceipt';

const CreateReceiptDashboard = () => {
  // const { userId = '' } = useAuth();

  // const userPro = useFetchUser(userId);

  // let user: User = {
  //   id: '',
  //   isConfirmed: false,
  //   email: ''
  // };
  // userPro.then(result => {
  //
  //   user = result.user;
  // })

  // const handleSubmit = useCallback(async () => {
  //     try {
  //         // await changePassword(payload);
  //         message.success('Success');
  //     } catch (error) {
  //         message.error((error as ApiError).message);
  //     }
  // }, [t]);

  // if (!user) {
  //   return <LoadingScreen />;
  // }

  return (
    <Routes>
      <Route
        element={
          <>
            <CreateReceipt />
            {/* <Table /> */}
          </>
        }
      >
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default CreateReceiptDashboard;
